import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, ScatterChart, Scatter, XAxis, YAxis, ZAxis, Tooltip } from 'recharts';

const y = 0;
const customComponent = 'circle';
const size = 10;

const DATA = [
  { x: 1, y, customComponent, size, label: 'Great', fill: '#8BBF42' },
  { x: 8, y, customComponent, size, label: 'Good', fill: '#C8C617' },
  { x: 13, y, customComponent, size, label: 'Okay', fill: '#FF6F02' },
  { x: 20, y, customComponent, size, label: 'Poor', fill: '#D0021B' },
];

class HealthScore extends PureComponent {
  static propTypes = {
    score: PropTypes.number.isRequired,
  }

  renderTooltip = (props) => {
    if (props.active && props.payload.length === 3) {
      const label = props.payload[2].value;
      return (
        <div className="bg-dark-gray ba br2 pa1">
          <p className="ma0 white">{label}</p>
        </div>
      );
    }
    return <noscript />;
  }

  render() {
    const { score } = this.props;
    return (
      <Fragment>
        <p className="tc f3">{score}</p>
        <ResponsiveContainer width="100%" height={60}>
          <ScatterChart>
            <XAxis
              type="number"
              dataKey="x"
              ticks={[1, 8, 13, 20]}
              tickLine={false}
              domain={[1, 20]}
            />
            <YAxis
              type="number"
              dataKey="y"
              height={4}
              width={0}
              domain={[0, 1]}
              tick={false}
              tickLine={false}
              axisLine={false}
            />
            <ZAxis
              type="category"
              dataKey="label"
            />
            <Tooltip cursor={false} content={this.renderTooltip} wrapperStyle={{ zIndex: 100 }} />
            {DATA.map(data => (
              <Scatter
                data={[{ x: data.x, y: data.y, label: data.label }]}
                name={data.label}
                fill={data.fill}
              />
            ))}
            <Scatter data={[{ x: score, y, label: `Your Score: ${score}` }]} shape="diamond" name="Your Score" fill="#375784" />
          </ScatterChart>
        </ResponsiveContainer>
      </Fragment>
    );
  }
}

export default HealthScore;
